import api from ".";
import { getToken } from "../Auth/Token";

export const getShippingSchedules = async () => {
  try {
    const token = getToken();

    const res = await api.get("/api/schedules", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data.data || []; 
  } catch (error) {
    console.error("Get Shipping Schedules API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const getCompletedShippingSchedules = async () => {
  try {
    const token = getToken();

    const res = await api.get("/api/schedules/completed", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res.data.data || []; 
  } catch (error) {
    console.error("Get Shipping Schedules API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const createShippingSchedule = async (payload) => {
  try {
    const token = getToken();

    const res = await api.post(
      "/api/schedules",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data; 
  } catch (error) {
    console.error("Create Shipping Schedule API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const updateShippingSchedule = async (id, payload) => {
  try {
    const token = getToken();

    const res = await api.put(
      `/api/schedules/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data.data;
  } catch (error) {
    console.error("Update Shipping Schedule API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const completeShippingSchedule = async (id) => {
  try {
    const token = getToken();

    const res = await api.put(
      `/api/schedules/${id}/complete`,
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data; 
  } catch (error) {
    console.error("Complete Shipping Schedule API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};

export const reorderShippingSchedules = async (orderedIds) => {
  try {
    const token = getToken();

    const res = await api.post(
      "/api/schedules/reorder",
      { orderedIds }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data; 
  } catch (error) {
    console.error("Reorder Shipping Schedules API Error:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    throw error;
  }
};